/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaceScan } from "@swan-admin/swan-web-component";
import { API_ENDPOINTS, REACT_APP_CONSUMER_TRYON_DOMAIN, FACE_SCAN,TOKEN_DATA_TYPE, PARAMS_PROP } from "../vars";
import apiClient from "../service/apiService";
import { UserDetailsContext } from "../context/userDetails";
import { capitalizeFirstLetter, encodingURL, getOriginFromUrl, handleGetUserDetails, handlePostHogCustomEvent } from "../utils/util";
import Asset from "./Asset/Asset";
import SpecificButton from "./specificButton/SpecificButton";

const totalCount = 30;
let count = 0;

function MuseGenerationStatus() {
	const [userDetails, setUserDetails] = useState(null);
	const [isMuseGenerated, setIsMuseGenerated] = useState(false);
	const { shopDomain, email, name, shopifyRedirectUrl, gender, userInfo, token } = useContext(UserDetailsContext);
	const [showError, setShowError] = useState(false);
	const navigate = useNavigate();

	const pollUserProfile = useCallback(() => {
		if (count > totalCount) {
			return;
		}
		const interval = setInterval(async () => {
			let data = null;
			try {
				count += 1;
				const res = await handleGetUserDetails();
				data = res?.data;
				if (data?.isMuseGenerated === "success" || count >= totalCount || data?.isMuseGenerated === "failed") {
					if (data?.isMuseGenerated === "success") {
						setIsMuseGenerated(true);
					} else {
						setShowError(true);
					}
					clearInterval(interval);
				}
			} catch (err) {
				console.log(err);
				if (count >= totalCount) {
					clearInterval(interval);
					setShowError(true);
				}
			} finally {
				handlePostHogCustomEvent(`${shopDomain}/userInfo`, { email, shopifyRedirectUrl, count, source: "fit-view", data: JSON.stringify(data) });
			}
		}, 120000);
		// eslint-disable-next-line consistent-return
		return () => clearInterval(interval);
	}, [shopDomain, email, shopifyRedirectUrl]);

	const handleMuseInit = useCallback(async () => {
		// setLoading(true);
		const requestSource = getOriginFromUrl(shopifyRedirectUrl);
		try {
			const res = await apiClient.post(
				API_ENDPOINTS.muse.museInit,
				{ requestSource },
				{
					headerToken: TOKEN_DATA_TYPE.ACCESS,
				},
			);
			handlePostHogCustomEvent(`${shopDomain}/muse_init`, { requestSource, email, data: JSON.stringify(res?.data) });
		} catch (error) {
			console.log(error);
			handlePostHogCustomEvent(`${shopDomain}/muse_init`, { requestSource, email, data: JSON.stringify(error) });
		} finally {
			pollUserProfile();
		}
	}, [shopDomain, email, pollUserProfile, shopifyRedirectUrl]);


	const handleMethods = useCallback(async () => {
		try {
			const [userRes] = await Promise.all([handleGetUserDetails()]);
			if (userRes?.data?.isMuseGenerated === "success") {
				setIsMuseGenerated(true);
				count = totalCount + 1;
			} else if (userRes?.data?.isMuseGenerated === "failed") {
				setShowError(true);
				count = totalCount + 1;
			}
			setUserDetails(userRes?.data);
			await handleMuseInit();
		} catch (error) {
			console.log(error);
		}
	}, [handleGetUserDetails, handleMuseInit, shopDomain, email]);

	const handleRedirect = () => {
		const url = new URL(shopifyRedirectUrl);
		url.searchParams.set("email", encodingURL(email));
		if (shopDomain === REACT_APP_CONSUMER_TRYON_DOMAIN) {
			url.searchParams.set(PARAMS_PROP.SILENT_AUTH,true);
		}
		window.location.href = url.toString();
	};

	const handleRescan = () => {
		navigate(FACE_SCAN);
	};

	useEffect(() => {
		if (shopDomain && email) {
			handleMethods();
		}
	}, [shopDomain, email]);

	return showError ? (
		<FaceScan
			isError
			onRetry={handleRescan}
		/>
	) : (
		<div className="w-full h-full flex bg-black text-center flex-col justify-between items-center  p-4">
			<h2 className="text-primary italic ">Creating &nbsp; {capitalizeFirstLetter(userDetails?.username || name)}&rsquo;s &nbsp; Muse</h2>
			<div className="flex justify-center items-center flex-1 fixed w-full h-full top-[50px]">
				<Asset />
			</div>

			{(isMuseGenerated && shopifyRedirectUrl) ? (
				<div className="fixed bottom-20 w-full flex justify-center">
					<SpecificButton buttonText="Close" btnSecondary buttonFunc={handleRedirect} />
				</div>
			) : (
				<div className="fixed bottom-5 text-white text-[12px] rounded-full border border-white px-4 py-2">Check your inbox in ~1 min</div>
			)}
		</div>
	);
}

export default MuseGenerationStatus;
